const THREE = window.THREE;

import dayjs from 'dayjs';
import moment from 'moment';
import Vue from 'vue';
import { log as debugLog, warn as debugWarn } from '@/utils/debugLogger';

export function $has(value, any = false) {
  value = value && typeof value == 'string' ? [value] : value;
  const user = $getFromLocal('user', true);
  if (!user) return false;
  let permissions = user.roles && user.roles.length > 0
    ? user.roles.flatMap(role => role.permissions || [])
    : [];
  permissions = permissions.map(({ name }) => name);
  let pass = false;
  if (value && Array.isArray(value))
    value.every((element) => {
      pass = permissions.includes(element) || element == 'All';
      if (any ? pass : !pass) return false;
      return true;
    });
  return pass;
}
export function $getFromLocal(name, parse = false, defaultValue) {
  let item = localStorage.getItem('R-' + name);
  if (item) {
    item = parse ? JSON.parse(item) : item;
    return item;
  }
  return defaultValue;
}

export function $getFromCookies(name) {
  const nameEQ = `R-${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ)
      === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function $getAuthHeaders() {
  // Check new localStorage token first, fallback to legacy cookie
  let token = $getFromLocal('accessToken', false, null);

  if (!token) {
    token = $getFromCookies("token");
  }

  if (!token) return {};

  return {
    Authorization: `Bearer ${token}`,
  };
}

export function $removeFromCookies(name) {
  document.cookie = `R-${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
export function $setToLocal(name, value, stringify = false) {
  localStorage.setItem('R-' + name, stringify ? JSON.stringify(value) : value);
}
export function $removeFromLocal(name) {
  if (Array.isArray(name)) {
    name.forEach((item) => {
      localStorage.removeItem('R-' + item);
    });
  } else {
    localStorage.removeItem('R-' + name);
  }
}
export function $handleError(error, validationErrorHandler) {
  if (error == 'Error: wait for token.') {
    return;
  }
  if (error.response && error.response.status === 401) {
    // var data = error.response.data;
    // if (data.ErrorType == 'Relogin') return;
    return;
  }
  let finalErrorText = '';
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    let errObj = error.response.data;
    switch (errObj.errorType) {
      case 'Validation':
        if (validationErrorHandler) {
          //  validationErrorHandler(errObj, error);
          return;
        }
        Vue.prototype.$dialog.notify.error(
          parseErrorsList(errObj.errors) || 'Unknown error occured!',
          {
            position: 'top-right',
            timeout: 6 * 1000,
          },
        );
        finalErrorText = parseErrorsList(errObj.errors) || 'Unknown error occured!';
        break;
      case 'BadRequest':
      default:
        Vue.prototype.$dialog.notify.error(
          errObj.errors || errObj.message || error.response.data || 'Unknown error occured!',
          {
            position: 'top-right',
            timeout: 6 * 1000,
          },
        );
        finalErrorText =
          errObj.errors || errObj.message || error.response.data || 'Unknown error occured!';
        break;
    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    Vue.prototype.$dialog.notify.error('Error receiving a response!', {
      position: 'top-right',
      timeout: 10 * 1000,
    });
    finalErrorText = 'Error receiving a response!';
  } else {
    // Something happened in setting up the request that triggered an Error
    Vue.prototype.$dialog.notify.error(error.message, {
      position: 'top-right',
      timeout: 10 * 1000,
    });
    finalErrorText = error.message;
  }

  return finalErrorText;
}
function parseErrorsList(errors) {
  if (!errors) return '';

  // Handle array format (new API format with code/description objects)
  if (Array.isArray(errors)) {
    return errors
      .map(err => {
        // Handle object with description property
        if (err && typeof err === 'object' && err.description) {
          return err.description;
        }
        // Handle string items
        if (typeof err === 'string') {
          return err;
        }
        return '';
      })
      .filter(Boolean)
      .join(', ');
  }

  // Handle object format (legacy format: { field: 'message' })
  if (typeof errors === 'object') {
    return Object.values(errors)
      .map(err => {
        if (err && typeof err === 'object' && err.description) {
          return err.description;
        }
        return err;
      })
      .filter(Boolean)
      .join(', ');
  }

  // Handle string format
  if (typeof errors === 'string') {
    return errors;
  }

  return '';
}
export function $getKeyByValue(object, value) {
  return Object.keys(object).find((key) => object[key] === value);
}
export function $isEqual(x, y) {
  const ok = Object.keys,
    tx = typeof x,
    ty = typeof y;
  return x && y && tx === 'object' && tx === ty
    ? ok(x).length === ok(y).length && ok(x).every((key) => $isEqual(x[key], y[key]))
    : x === y;
}
export function $addToArr(arr, element, onTop = false) {
  if (onTop) arr.unshift(element);
  else Vue.set(arr, arr.length, element);
}
export function $updateArr(arr, element, key = 'id') {
  const index = arr.findIndex((elm) => elm[key] == element[key]);
  if (index > -1) {
    Vue.set(arr, index, element);
  }
}
export function $updateOrAdd(arr, element, key = 'id', onTop = false) {
  const index = arr.findIndex((elm) => elm[key] == element[key]);
  if (index > -1) {
    Vue.set(arr, index, element);
  } else {
    $addToArr(arr, element, onTop);
  }
}
export function $updateOrAddSilent(arr, element, key = 'id', onTop = false) {
  const index = arr.findIndex((elm) => elm[key] == element[key]);
  if (index > -1) {
    arr[index] = element;
  } else {
    if (onTop) arr.unshift(element);
    else arr.push(element);
  }
}

export function $deleteFromArray(arr, id, key = 'id') {
  const index = arr.findIndex((elm) => elm[key] == id);
  if (index !== -1) arr.splice(index, 1);
}

export function $simpleId() {
  return Math.random().toString(36).substring(2, 8);
}

function createTree(data) {
  let permissions = {};

  data.forEach(item => {
    let levels = item.name.split('.');
    let currentLevel = permissions;

    levels.forEach((level, index) => {
      if (!currentLevel[level]) {
        currentLevel[level] = {
          name: level,
          id: index === levels.length - 1 ? item.id : Math.random() * 100,
          children: {}
        };
      }

      currentLevel = currentLevel[level].children;
    });
  });

  // Convert nested children objects to arrays
  function convertToArray(node) {
    if (node.children && Object.keys(node.children).length > 0) {
      node.children = Object.values(node.children).map(convertToArray);
    } else {
      delete node.children;
    }
    return node;
  }

  return Object.values(permissions).map(convertToArray);
}
export function $mapToTree(data) {

  let permissions = [];
  var res= createTree(data);

  permissions.push({
    id: 'all',
    name: 'All Permissions',
    children: res,
  });
  debugLog('index', 'Mapped permissions tree:', permissions);
  return permissions;
}

const MAIN_GROUPING_ORDER = [
  'View & Navigation',
  'Data & Docs',
  'Management',
  'Integrity',
  'Facility Admin',
  'Admin'
];

export function $mapToGroupedTree(data) {
  // Group permissions by mainGrouping
  const groupingMap = {};

  data.forEach(item => {
    const mainGrouping = item.mainGrouping || 'Other';
    if (!groupingMap[mainGrouping]) {
      groupingMap[mainGrouping] = [];
    }
    groupingMap[mainGrouping].push(item);
  });

  // Sort groupings by recommended display order
  const sortedGroupings = Object.keys(groupingMap).sort((a, b) => {
    const indexA = MAIN_GROUPING_ORDER.indexOf(a);
    const indexB = MAIN_GROUPING_ORDER.indexOf(b);
    if (indexA === -1 && indexB === -1) return a.localeCompare(b);
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });

  // Build tree with mainGrouping as Level 1
  const tree = [];

  sortedGroupings.forEach(grouping => {
    const groupPermissions = createTree(groupingMap[grouping]);
    tree.push({
      id: `grouping::${grouping}`,
      name: grouping,
      children: groupPermissions
    });
  });

  debugLog('index', 'Mapped grouped permissions tree:', tree);
  return tree;
}
export function $splitCamelCase(input, separator = ' ') {
  // return input.replace(/([a-z])([A-Z])/g, `$1${separator}$2`);
  
  // Predefined camelCase word list
  const camelCaseWords = [
    'ReCap',
  ];
  
  // Find all camelCase boundaries
  const boundaries = [];
  for (let i = 0; i < input.length - 1; i++) {
    if (/[a-z]/.test(input[i]) && /[A-Z]/.test(input[i + 1])) {
      boundaries.push(i);
    }
  }
  
  // Check each boundary to see if it's inside a special word
  const protectedBoundaries = new Set();
  
  for (const boundary of boundaries) {
    const position = boundary + 1; // Position of the uppercase letter
    
    // Check if this position is inside any of our special words
    for (const word of camelCaseWords) {
      for (let start = Math.max(0, position - word.length + 1); start <= position; start++) {
        const end = start + word.length;
        if (end > input.length) continue;
        
        const substring = input.substring(start, end);
        if (substring === word) {
          protectedBoundaries.add(boundary);
          break;
        }
      }
    }
  }
  
  // Split at unprotected boundaries
  let result = input;
  for (let i = boundaries.length - 1; i >= 0; i--) {
    const boundary = boundaries[i];
    if (!protectedBoundaries.has(boundary)) {
      result = result.substring(0, boundary + 1) + separator + result.substring(boundary + 1);
    }
  }
  
  return result;
}
export function $getURLParameterVal(key, base64 = false) {
  if (!window.location.search) {
    return;
  }
  var params = new URLSearchParams(document.location.search);
  var result = params.get(key);
  if (result && base64) {
    result.replace('%3D', '');
    return atob(result);
  }
  return result;
}
export function $formatDate(date, format = 'DD/MM/YYYY') {
  return date ? dayjs(date).format(format) : date;
}
export function $uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
  );
}

export function $clean(obj, cleanEmptyArray = false) {
  var source = Object.assign({}, obj);
  Object.keys(source).forEach((key) => {
    if (
      (!source[key] && source[key] !== false) ||
      (cleanEmptyArray && Array.isArray(source[key]) && !source[key].length)
    )
      delete source[key];
  });
  return source;
}
export function $getQueryParams(obj, clean = true) {
  const queryParams = new URLSearchParams();
  if (clean) obj = $clean(obj, true);
  // Loop through each filter in the object
  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      // Check if the value is an array
      if (Array.isArray(value)) {
        // If it's an array, append each value separately
        value.forEach((val) => {
          queryParams.append(key, val);
        });
      } else {
        // If it's not an array, append the single value
        queryParams.append(key, value);
      }
    }
  }
  return queryParams;
}
export function $isNumbersOnly(input) {
  const regex = /^[0-9]+$/;
  return regex.test(input);
}
export function $hexToVector4(hex) {
  // Remove the # if it's present
  hex = hex.replace('#', '');

  // Pad incomplete hex strings
  if (hex.length === 3) {
    // e.g., '123' -> '112233'
    hex = hex.split('').map(c => c + c).join('');
  } else if (hex.length === 4) {
    // e.g., '1234' -> '11223344'
    hex = hex.split('').map(c => c + c).join('');
  } else if (hex.length === 6) {
    // e.g., '112233' remains '112233'
  } else if (hex.length === 8) {
    // e.g., '11223344' remains '11223344'
  } else {
    throw new Error("Invalid hex color format. Use either RGB (3 or 6 characters) or RGBA (4 or 8 characters).");
  }

  let r, g, b, a = 1.0; // Default opacity to 1.0 if not provided

  if (hex.length === 8) {
    // If the hex color has an alpha value (8 characters: RRGGBBAA)
    r = parseInt(hex.substring(0, 2), 16) / 255;
    g = parseInt(hex.substring(2, 4), 16) / 255;
    b = parseInt(hex.substring(4, 6), 16) / 255;
    a = parseInt(hex.substring(6, 8), 16) / 255;
  } else if (hex.length === 6) {
    // If the hex color doesn't have an alpha value (6 characters: RRGGBB)
    r = parseInt(hex.substring(0, 2), 16) / 255;
    g = parseInt(hex.substring(2, 4), 16) / 255;
    b = parseInt(hex.substring(4, 6), 16) / 255;
  }

  // Create and return a new THREE.Vector4 object
  return new THREE.Vector4(r, g, b, a);
}
export function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function $truncateString(str, length = 10) {
  if (!str) return '';
  return str.length > length ? str.substring(0, length) + '...' : str;
}

export function $timeElapsed(commentCreatedAt) {
  if (!commentCreatedAt) return 'unknown';
  let createdAtDate;

  try {
    // Handle different input types and formats
    if (typeof commentCreatedAt === 'string') {
      let dateString = commentCreatedAt.trim();

      // For ISO strings without timezone, assume they are UTC
      if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?$/.test(dateString)) {
        // Add Z to indicate UTC if not present
        createdAtDate = new Date(dateString + 'Z');
      } else if (dateString.includes('Z') || /[+-]\d{2}:?\d{2}$/.test(dateString)) {
        // Already has timezone info
        createdAtDate = new Date(dateString);
      } else {
        // Try parsing as-is first, then assume UTC if needed
        createdAtDate = new Date(dateString);
        // If the parse was successful but we suspect it should be UTC
        if (!isNaN(createdAtDate.getTime()) && !dateString.includes('Z') && dateString.includes('T')) {
          // Re-parse as UTC
          createdAtDate = new Date(dateString + 'Z');
        }
      }
    } else if (typeof commentCreatedAt === 'number') {
      // Handle timestamps (both seconds and milliseconds)
      createdAtDate = new Date(commentCreatedAt < 1e12 ? commentCreatedAt * 1000 : commentCreatedAt);
    } else {
      // Handle Date objects
      createdAtDate = new Date(commentCreatedAt);
    }

    // Validate the parsed date
    if (isNaN(createdAtDate.getTime())) {
      return 'unknown';
    }

  } catch (error) {
    return 'unknown';
  }

  const now = new Date();
  const diffInMs = now.getTime() - createdAtDate.getTime();

  // Handle future dates
  if (diffInMs < 0) {
    return 'just now';
  }

  // Convert to time units
  const seconds = Math.floor(diffInMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (years > 0) {
    return years === 1 ? '1 year ago' : `${years} years ago`;
  } else if (months > 0) {
    return months === 1 ? '1 month ago' : `${months} months ago`;
  } else if (weeks > 0) {
    return weeks === 1 ? '1 week ago' : `${weeks} weeks ago`;
  } else if (days > 0) {
    return days === 1 ? '1 day ago' : `${days} days ago`;
  } else if (hours > 0) {
    return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
  } else if (minutes > 0) {
    return minutes === 1 ? '1 minute ago' : `${minutes} minutes ago`;
  } else if (seconds > 30) {
    return `${seconds} seconds ago`;
  } else {
    return 'just now';
  }
}

export function $updateManually(source, item) {
  for (let key in item) {
    if (item[key] !== null && item[key] !== undefined) {
      source[key] = item[key];
    }
  }
}

export function $deepCompare(obj1, obj2) {
  const changes = {};

  function compare(obj1, obj2, path = '') {
    for (const key in obj1) {
      if (Object.prototype.hasOwnProperty.call(obj1, key)) {
        const newPath = path ? `${path}.${key}` : key;
        if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
          // Compare arrays
          if (!arraysEqual(obj1[key], obj2[key])) {
            changes[newPath] = { oldValue: obj1[key], newValue: obj2[key] };
          }
        } else if (typeof obj1[key] === 'object' && obj1[key] !== null) {
          compare(obj1[key], obj2[key], newPath);
        } else if (obj1[key] !== obj2[key]) {
          changes[newPath] = { oldValue: obj1[key], newValue: obj2[key] };
        }
      }
    }

    for (const key in obj2) {
      if (Object.prototype.hasOwnProperty.call(obj2, key) && !Object.prototype.hasOwnProperty.call(obj1, key)) {
        const newPath = path ? `${path}.${key}` : key;
        changes[newPath] = { oldValue: undefined, newValue: obj2[key] };
      }
    }
  }

  function arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }

  compare(obj1, obj2);
  return changes;
}

export function formatDate(dateString, format = 'YYYY-MM-DD') {

  let date = moment(dateString);
  if (date.isValid()) {
    return date.format(format);
  }

  let formats = [
    "DD/MM/YYYY", "MM/DD/YYYY", "YYYY/MM/DD",                   // with '/'
    "DD-MM-YYYY", "MM-DD-YYYY", "YYYY-MM-DD",                   // with '-'
    "D/MM/YYYY", "DD/M/YYYY", "YYYY/MM/D", "YYYY/MM/DD",        // single-digit day/month with '/'
    "D-MM-YYYY", "DD-M-YYYY", "YYYY-MM-D", "YYYY-M-DD"          // single-digit day/month with '-'
  ];

  date = moment(dateString, formats, true);
  if (date.isValid()) {
    return date.format(format);
  }

  return dateString;
}

export function executeWhen(conditionFn, actionFn, interval = 10, maxAttempts = Infinity) {

  if (typeof conditionFn !== 'function') {
      throw new Error('Condition must be a function');
  }
  if (typeof actionFn !== 'function') {
      throw new Error('Action must be a function');
  }
  if (typeof interval !== 'number' || interval <= 0) {
      throw new Error('Interval must be a positive number');
  }
  if (typeof maxAttempts !== 'number' || maxAttempts <= 0) {
      throw new Error('Max attempts must be a positive number or Infinity');
  }

  let attempts = 0;
  const intervalId = setInterval(() => {
      attempts++;

      if (attempts > maxAttempts) {
          clearInterval(intervalId);
          debugWarn('index', 'Max attempts reached, stopping execution.');
          return;
      }

      if (conditionFn()) {
          clearInterval(intervalId); // Stop the interval
          actionFn(); // Fire the action function
      }
  }, interval);

  return function stop() {
      clearInterval(intervalId);
      debugLog('index', 'Execution stopped manually.');
  };
}

export function $searchNodes(data, criteria, childrenKey = 'children') {
  const results = [];

  // Check if the current node matches the criteria
  function isMatch(node) {
    return Object.keys(criteria).every(key => node[key] === criteria[key]);
  }

  // Recursive function to traverse the nodes
  function traverse(node) {
    if (isMatch(node)) {
      results.push(node); // Add matching node to results
    }
    // If children exist, traverse each child
    if (Array.isArray(node[childrenKey])) {
      node[childrenKey].forEach(child => traverse(child));
    }
  }

  // Handle both array and object inputs
  if (Array.isArray(data)) {
    data.forEach(node => traverse(node));
  } else if (typeof data === 'object' && data !== null) {
    traverse(data);
  }

  return results;
}

/**
   * Gets the correct image path for a color, handling case sensitivity
   * @param {string} color - The color hex code without #
   * @returns {string} The image path
   */
export function getColorImagePath(color) {
  try {
    // Try the original case first
    return require(`@/images/tags-icons/by-color/${color}-hover.png`);
  } catch (error) {
    try {
      // Try uppercase
      return require(`@/images/tags-icons/by-color/${color.toUpperCase()}-hover.png`);
    } catch (error) {
      try {
        // Try lowercase
        return require(`@/images/tags-icons/by-color/${color.toLowerCase()}-hover.png`);
      } catch (error) {
        // Fallback to a default image or throw a more descriptive error
        debugWarn('index', `Image not found for color ${color}. Available cases tried: original, uppercase, lowercase`);
        // You can return a default image path here or rethrow the error
        throw new Error(`Image not found for color ${color} in any case variation`);
      }
    }
  }
}

/**
 * Creates a canvas-based icon using shader logic for dynamic color generation
 * @param {string} color - Hex color string (with or without #)
 * @param {number} size - Icon size in pixels (default: 50)
 * @param {boolean} isHover - Whether to show hover state with rings (default: false)
 * @returns {string} Data URL of the generated icon
 */
export function generateDynamicIcon(color, size = 50, isHover = false) {
  // Normalize color to hex without #
  const normalizedColor = color.replace('#', '');

  // Convert hex to RGB values (0-1 range)
  const r = parseInt(normalizedColor.substr(0, 2), 16) / 255;
  const g = parseInt(normalizedColor.substr(2, 2), 16) / 255;
  const b = parseInt(normalizedColor.substr(4, 2), 16) / 255;

  // Create canvas
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');

  // Clear canvas
  ctx.clearRect(0, 0, size, size);

  // Apply the same shader logic as tagsFragmentShader
  for (let x = 0; x < size; x++) {
    for (let y = 0; y < size; y++) {
      // Convert pixel coordinates to shader coordinates (0-1 range, centered)
      const pos = {
        x: x / size,
        y: y / size
      };

      const shaderCenter = { x: 0.5, y: 0.5 };
      const distance = Math.sqrt(
        Math.pow(pos.x - shaderCenter.x, 2) +
        Math.pow(pos.y - shaderCenter.y, 2)
      );

      let alpha = 0;

      if (isHover) {
        // Hover state - same proportions as shader
        const solidRadius = 0.25;      // 50% center circle
        const ring1Start = 0.345;      // After 15% gap
        const ring1End = 0.375;        // 10% ring thickness
        const ring2Start = 0.47;       // After 15% gap
        const ring2End = 0.5;          // 10% outer ring

        // Solid center circle
        const innerCircle = distance <= solidRadius ? 1.0 : 0.0;

        // First ring
        const ring1 = (distance >= ring1Start && distance <= ring1End) ? 1.0 : 0.0;

        // Second ring
        const ring2 = (distance >= ring2Start && distance <= ring2End) ? 1.0 : 0.0;

        // Combine all elements
        alpha = Math.max(innerCircle, Math.max(ring1, ring2));

        // Apply 90% opacity for hover state
        alpha = alpha * 0.9;
      } else {
        // Normal state - simple filled circle
        const normalRadius = 0.25; // Same as hover solid center
        alpha = distance <= normalRadius ? 1.0 : 0.0;
      }

      // Set pixel if alpha > threshold
      if (alpha > 0.05) {
        ctx.fillStyle = `rgba(${Math.round(r * 255)}, ${Math.round(g * 255)}, ${Math.round(b * 255)}, ${alpha})`;
        ctx.fillRect(x, y, 1, 1);
      }
    }
  }

  return canvas.toDataURL();
}

/**
 * Cache for generated icons to avoid regenerating the same icons
 */
const iconCache = new Map();

/**
 * Gets a cached dynamic icon or generates a new one
 * @param {string} color - Hex color string
 * @param {number} size - Icon size in pixels
 * @param {boolean} isHover - Whether to show hover state
 * @returns {string} Data URL of the icon
 */
export function getCachedDynamicIcon(color, size = 50, isHover = false) {
  const cacheKey = `${color}_${size}_${isHover}`;

  if (!iconCache.has(cacheKey)) {
    iconCache.set(cacheKey, generateDynamicIcon(color, size, isHover));
  }

  return iconCache.get(cacheKey);
}

/**
 * Formats a file size in bytes to a human-readable string with appropriate units
 * @param {number} bytes - The file size in bytes
 * @param {number} decimals - Number of decimal places to show (default: 2)
 * @returns {string} Formatted file size with unit (e.g., "1.5 MB")
 */
export function formatFileSize(bytes, decimals = 2) {
  if (bytes === 0) return '0 MB';
  if (bytes === undefined || bytes === null) return 'N/A';
  
  const k = 1024*1024;
  const sizes = [ 'MB', 'GB', 'TB', 'PB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i];
}

/**
 * Strips query parameters from a URL, returning only the base URL
 * @param {string} url - The URL to strip query params from
 * @returns {string} The URL without query parameters
 */
export function $stripQueryParams(url) {
  if (!url) return url;
  try {
    const urlObj = new URL(url);
    return urlObj.origin + urlObj.pathname;
  } catch {
    return url.split('?')[0];
  }
}

Object.defineProperty(String.prototype, 'capitalize', {
  value: function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false
});